// Utility function to read cookies
const getCookie = (name) => {
  if (typeof window !== "undefined") {
    const value = `; ${document.cookie}`
    const parts = value.split(`; ${name}=`)
    if (parts.length === 2) {
      const cookieValue = parts.pop().split(";").shift()
      return cookieValue
    }
  }
  return null // Return null if not in a browser environment
}

// Utility function to set cookies
const setCookie = (name, value, days = 90, path = "/") => {
  if (typeof window !== "undefined") {
    const expires = new Date()
    expires.setTime(expires.getTime() + days * 24 * 60 * 60 * 1000)
    document.cookie = `${name}=${value};expires=${expires.toUTCString()};path=${path}`

    // Log in dev mode
    if (process.env.NODE_ENV === "development") {
      console.log(`Cookie set: ${name}=${value} (expires in ${days} days)`)
    }
  }
}

// Check URL for tracking parameters and store in cookies
const storeTrackingParamsFromUrl = () => {
  if (typeof window !== "undefined") {
    const urlParams = new URLSearchParams(window.location.search)
    const trackingParams = ["gclid", "fbclid", "ttclid", "msclkid"]

    trackingParams.forEach((param) => {
      const value = urlParams.get(param)
      if (value) {
        // Store with the same param name
        setCookie(param.toLowerCase(), value)
      }
    })
  }
}

// Get all tracking cookies as an object
const getTrackingCookies = () => {
  const trackingParams = ["gclid", "fbclid", "ttclid", "msclkid"]
  const result = {}

  trackingParams.forEach((param) => {
    const value = getCookie(param.toLowerCase())
    if (value) {
      result[param.toLowerCase()] = value
    }
  })

  return result
}

module.exports = {
  getCookie,
  setCookie,
  storeTrackingParamsFromUrl,
  getTrackingCookies
}
